<template>
  <div style="border-top: thin solid rgba(0, 0, 0, 0.12)">
    <v-toolbar flat color="#fff" style="margin-top: 8px">
      <v-row align="center" style="padding-bottom: 3px">
        <v-spacer></v-spacer>
        <v-col cols="2" style="max-width: 150px">
          <v-select
            class="mt-5"
            dense
            :items="pageSizes"
            label="Items Per Page"
            :value="pageSize"
            :menu-props="{ top: true, offsetY: true, maxHeight: 500 }"
            @change="$emit('update:pageSize', $event)">
          </v-select>
        </v-col>
        <v-btn
          icon
          large
          @click="$emit('previous')"
          :disabled="disablePrevious"
          class="mx-2">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <small>Page {{ page }}</small>
        <v-btn
          icon
          large
          @click="$emit('next')"
          :disabled="disableNext"
          class="mx-2">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-col cols="auto" class="d-flex align-center py-0">
            <slot name='footer-button' />
        </v-col>
      </v-row>
    </v-toolbar>
  </div>
</template>
<script>
export default {
  name: 'PagingFooter',
  props: {
    pageSize: Number,
    pageSizes: Array,
    page: Number,
    disablePrevious: Boolean,
    disableNext: Boolean
  }
}
</script>